import { IPublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { ReactNode, useEffect, useRef, useState } from "react";

import { AzureAuthConfiguration } from "../azure-auth.types";
import { getOrCreateAzureAuthInstance } from "../utils";

type Props = {
    configuration: AzureAuthConfiguration;
    children: ReactNode;
};

export const AzureAuthProvider = ({ configuration, children }: Props) => {
    const [azureAuthInstance, setAzureAuthInstance] = useState<IPublicClientApplication | null>(null);
    const isInitializedRef = useRef(false);

    useEffect(() => {
        if (isInitializedRef.current) return; // Early return if already initialized

        const retrieveAzureAuthInstance = async () => {
            const instance = await getOrCreateAzureAuthInstance(configuration);
            setAzureAuthInstance(instance);
            isInitializedRef.current = true; // Set the flag after successful initialization
        };

        retrieveAzureAuthInstance();
    }, []);

    if (!azureAuthInstance) return null;

    return <MsalProvider instance={azureAuthInstance}>{children}</MsalProvider>;
};
